import { type FC } from 'react';

import {
  type PaidSpecContractType,
  type SpecContractStatusType,
  type SpecContractType,
} from '@/common/types/contract';
import { Picture } from '@/components/ui/Picture/Picture';

import { getBgImage } from './config';

interface BackgroundProps {
  kind: SpecContractType | PaidSpecContractType;
  status: SpecContractStatusType;
}

const Background: FC<BackgroundProps> = ({ kind, status }) => {
  const pictureProps = getBgImage(kind)[status];

  return (
    <Picture
      {...pictureProps}
      className="absolute inset-0 pointer-events-none -z-[1]"
      alt={`${kind}-${status}`}
    />
  );
};

export { Background };
